import { useMotionStudioModalBase } from 'modules/campaigns/modules/creative-creator/components/VariationsCreation/hooks/useMotionStudioModalBase';
import { useMediaTabsContext } from '../MediaTabsContextProvider/MediaTabsContextProvider';

export const useMotionStudioModal = props => {
    const { campaignId, titleList } = useMediaTabsContext();

    return useMotionStudioModalBase({ campaignId, titleList, ...props });
};
